/** Poly Studio conversations base for Razormetrics US (see AI Call Log feature). */
const POLY_STUDIO_CONVERSATIONS_BASE =
  "https://studio.us.poly.ai/razormetrics-us/razormetrics-usp/conversations/";

/**
 * @param {string} aiCallSid — Poly call SID (`AiCallLogRowDto.aiCallSid`)
 */
export function getPolyStudioConversationUrl(aiCallSid) {
  if (!aiCallSid) return null;
  const base = POLY_STUDIO_CONVERSATIONS_BASE.replace(/\/?$/, "/");
  return `${base}${encodeURIComponent(aiCallSid)}`;
}

/**
 * @param {string} callGroupUuid
 */
export function getCallGroupActivityUrl(callGroupUuid) {
  if (!callGroupUuid) return null;
  const path = `/agent-workspace/call-group-details/${callGroupUuid}`;
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
}
